
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Discount, DiscountFormValues } from "@/types/discount";
import { DiscountForm } from "./DiscountForm";

interface EditDiscountDialogProps {
  discount: Discount | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDiscountUpdated: () => void;
}

export const EditDiscountDialog = ({
  discount,
  open,
  onOpenChange,
  onDiscountUpdated,
}: EditDiscountDialogProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!discount) return null;

  const initialValues: DiscountFormValues = {
    school_id: discount.school_id,
    plan_id: discount.plan_id,
    product_id: discount.product_id,
    discount_type: discount.discount_type,
    discount_value: discount.discount_value,
    status: discount.status,
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Discount</DialogTitle>
        </DialogHeader>
        <DiscountForm
          initialValues={initialValues}
          isSubmitting={isSubmitting}
          setIsSubmitting={setIsSubmitting}
          onSuccess={() => {
            onDiscountUpdated();
            onOpenChange(false);
          }}
          mode="edit"
          discountId={discount.id}
        />
      </DialogContent>
    </Dialog>
  );
};
